<template lang="pug">
  v-card
    v-card-title.primary--text.justify-center.grey.lighten-4
      .title CONSOMMATION RÉELE : {{ currentYear }}
    v-card-text.pa-0
      v-layout
        v-flex.xs5.pa-3
          v-layout.align-center.column
            .title.font-weight-regular.text-xs-center
              div Consommation
              div depuis le 1er Janvier {{ currentYear }} :
            v-layout.align-center
              span.display-1.font-weight-bold.my-3(
                data-test="yearNConsumption"
              ) {{ yearly | spaceOut }}
              span.subheading.pl-2 Affichages
        v-divider.grey(vertical)
        v-flex.xs7.pa-3
          v-layout.align-center.column
            .title.font-weight-regular.text-xs-center Forfait autorisé :
            v-layout.pt-2.align-center
              .display-1.font-weight-bold {{ offer.consumption_limit | spaceOut }}
              .subheading.pl-2 Affichages
            span.pt-4
              span.display-1.font-weight-bold {{ offer.price }}€ HT
              span.headline.grey--text /mois
              span.black--text.line-through.pl-3(
                v-if="offer.discount"
              ) ({{ offer.catalog_price }}€ HT)
              span(v-if="offer.discount")  :  Remisé de
              span.primary--text(v-if="offer.discount")  {{ offer.discount }}
</template>

<script>
export default {
  computed: {
    currentYear() {
      return this.$store.state.consumption.currentYear;
    },
    offer() {
      return this.$store.state.consumption.consumption.this_year_offer || {};
    },
    yearly() {
      if (this.$store.state.consumption.consumption.this_year_reports) {
        return this.$store.state.consumption.consumption.this_year_reports
          .filter(x => parseInt(x.year, 10) === this.currentYear)
          .reduce((total, current) => total + current.quantity, 0);
      }
      return 0;
    },
  },
};
</script>
